import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";
import { TrioPermission } from "./useGetRoles";

export interface TrioRole {
  id: string;
  name: string;
  description: string;
  companyId?: string;
  employeesCount?: number;
  permissions: TrioPermission[];
  icon?: string;
}

type TArgumants = {
  search?: string;
};

export const useGetTrioRoles = (params?: TArgumants) => {
  return useQuery({
    queryFn: () =>
      MyAxios.get<TrioRole[]>("/acl/company-roles", {
        params,
      }).then((res) => res.data),
    queryKey: ["TrioRoles", params],
  });
};
